import { BookOpen, Lightbulb, Music, Heart, Clock } from "lucide-react";
import { motion } from "framer-motion";

const ROWS = [
  { icon: BookOpen, label: "Choose a Story", value: "Luna's Cloud Castle" },
  { icon: Lightbulb, label: "Lights", value: "Warm Moonlight · 40%" },
  { icon: Music, label: "Sounds", value: "Gentle Rain" },
  { icon: Heart, label: "Favorites", value: "12 saved" },
  { icon: Clock, label: "Sleep Timer", value: "30 minutes" },
];

export default function PhoneMockup() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60, rotate: 4 }} whileInView={{ opacity: 1, y: 0, rotate: 0 }}
      viewport={{ once: true }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className="relative mx-auto w-72 rounded-[2.5rem] border-4 border-white/15 bg-night p-3 shadow-2xl"
      data-testid="app-phone-mockup">
      <div className="overflow-hidden rounded-[2rem] bg-navy">
        <div className="flex items-center justify-between px-5 pt-5">
          <img src="/assets/logo.png" alt="Bedtime Buddies app" className="h-8 w-auto" />
          <span className="h-2 w-2 rounded-full bg-moon animate-glow-pulse" />
        </div>
        <div className="space-y-2.5 p-4">
          {ROWS.map((row, i) => (
            <motion.div key={row.label}
              initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }} transition={{ delay: 0.15 + i * 0.1 }}
              className="flex items-center gap-3 rounded-2xl bg-white/8 border border-white/10 px-4 py-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-pink/20 text-pink">
                <row.icon size={16} />
              </span>
              <div className="flex-1">
                <p className="text-xs font-bold text-cloud">{row.label}</p>
                <p className="text-[11px] text-cloud/50">{row.value}</p>
              </div>
            </motion.div>
          ))}
          <div className="rounded-2xl bg-lavender/15 border border-lavender/25 px-4 py-3">
            <p className="text-[11px] font-bold text-lavender">Volume</p>
            <div className="mt-2 h-1.5 rounded-full bg-white/10">
              <div className="h-full w-2/5 rounded-full bg-gradient-to-r from-sky to-lavender" />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
